import moment from 'moment';

const HOURS = 24;
export const HOUR_FORMAT = 'hh:mm a';

export default function hourOptions() {
  return Array.from(
    new Array(HOURS),
    (x, hour) => moment().hour(hour).minutes(0).format(HOUR_FORMAT),
  );
}



// WEBPACK FOOTER //
// ./app/components/KdSelectDate/hourOptions.js